import React from 'react';
import { formatCurrency } from '../../../components/ui';

export const MetricsGrid = ({ analytics }) => {
  return (
    <div className="card p-5 border border-gray-100 rounded-xl shadow-sm bg-white">
      <h3 className="font-serif text-lg text-slate-800 font-medium mb-4">Operations Overview</h3>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {[
          { label: 'Total Contacts', value: `${analytics.totalContacts || 0}`, color: 'text-slate-800', bg: 'bg-slate-50' },
          { label: 'Total Leads', value: analytics.totalLeads || 0, color: 'text-blue-600', bg: 'bg-blue-50' },
          { label: 'Total Projects', value: analytics.totalProjects || 0, color: 'text-purple-600', bg: 'bg-purple-50' },
          { label: 'Total Pipeline Value', value: formatCurrency(analytics.totalPipelineValue || 0), color: 'text-green-600', bg: 'bg-green-50' },
        ].map(({ label, value, color, bg }) => (
          <div key={label} className={`rounded-xl p-5 ${bg} flex flex-col items-center justify-center text-center transition-all duration-300 hover:scale-[1.02] border border-black/5`}>
            <div className={`text-2xl font-bold font-serif ${color} mb-1`}>{value}</div>
            <div className="text-sm font-medium text-slate-500">{label}</div>
          </div>
        ))}
      </div>
    </div>
  );
};





